export default "__VITE_ASSET__DgLdBoC5__"